// import events and types from react
import { MouseEvent, FC } from 'react';

// import components
import { Tooltip } from '@mui/material';
import { DataGridAction } from '../DataGrid.types';

// import types
import {
  GridActionsCellItem,
  GridRenderCellParams
} from '@mui/x-data-grid-pro';
import { Icon } from '@sdb/planning-ui';

interface Props {
  action: DataGridAction;
  params: GridRenderCellParams;
}

export const CustomDataGridAction: FC<Props> = ({ action, params }) => {
  const tooltip =
    typeof action.tooltipTitle === 'function'
      ? action.tooltipTitle(params.id, params.row)
      : action.tooltipTitle;
  const icon =
    typeof action.icon === 'function'
      ? action.icon(params.id, params.row)
      : action.icon;

  if (action.hidden) {
    return null;
  }

  return (
    <Tooltip key={tooltip} title={tooltip} arrow>
      <GridActionsCellItem
        size="small"
        label={tooltip}
        icon={<Icon type={icon} fontSize="small" />}
        onClick={(event: MouseEvent<HTMLButtonElement>) => {
          action.onClick && action.onClick(params.id, params.row, event);
        }}
      />
    </Tooltip>
  );
};
